import React from 'react'
import DismissIcon from 'icons/Dismiss'

const FormMessage = ({ type, showMessage, message, handleDismiss }) => {
  if (!showMessage || !message) return null
  let messageType
  switch (type) {
    case 'error':
      messageType = 'formMessage--error'
      break
    case 'success':
      messageType = 'formMessage--success'
      break
    default:
      messageType = ''
  }
  return (
    <div className={`formMessage ${messageType}`}>
      {handleDismiss && (
        <a className='formMessage__dismiss' onClick={handleDismiss}>
          <DismissIcon />
        </a>
      )}
      <p>{message}</p>
    </div>
  )
}

export default FormMessage
